import { IMask } from 'react-imask';

export const numberMask: IMask.AnyMaskedOptions = {
  mask: Number,
};

export const formattedNumberMask: IMask.AnyMaskedOptions = {
  mask: Number,
  scale: 0,
  signed: false,
  thousandsSeparator: ',',
};

export const phoneNumberMask: IMask.AnyMaskedOptions = {
  mask: '(000) 000-0000',
};
